import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentText: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
    <Path
      d='M5 4.75A.75.75 0 015.75 4h12.5a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0V5.5h-4.75v13h1.5a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h1.5v-13H6.5v1.25a.75.75 0 01-1.5 0v-2z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentText
